import React, { useState } from 'react';
import LocationForm from './LocationForm';

function AddLocation() {
  const [form, setForm] = useState({
    location_name: '',
    address_line1: '',
    address_line2: '',
    city: '',
    latitude: '',
    longitude: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = localStorage.getItem('authToken');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const res = await fetch('/api/locations', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(form)
    });

    if (res.ok) {
      alert('Location added!');
      setForm({ location_name: '', address_line1: '', address_line2: '', city: '', latitude: '', longitude: '' });
    } else {
      const data = await res.json();
      alert(data.message || 'Error adding location');
    }
    setIsSubmitting(false);
  };

  return <LocationForm form={form} onChange={handleChange} onSubmit={handleSubmit} isSubmitting={isSubmitting} />;
}

export default AddLocation;
